export default "__VITE_ASSET__44db6de0__"